export default "__VITE_ASSET__DHfHZ0TG__"